import React, { useState, useEffect } from 'react';
import './style/TargetingStyle.css';
import "dual-listbox/dist/dual-listbox.css";



interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    campaignName: string;
    [key: string]: string;
  };
}

const TargetingStep: React.FC<StepProps> = ({ handleInputChange, formData }) => {
  const [isRadioChecked, setIsRadioChecked] = useState(false); // State to track radio button
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false); // State to track text box visibility
  const [isTextBoxVisible1, setIsTextBoxVisible1] = useState(false); // State to track text box visibility

  const [isRadioChecked1, setIsRadioChecked1] = useState(false); // State to track radio button

  const [keywords, setKeywords] = useState(''); // State for keywords
  const [availableKeywords, setAvailableKeywords] = useState<any[]>([]); // State for available keywords
  const [selectedKeywords, setSelectedKeywords] = useState<any[]>([]); // State for selected keywords

  const handleKeywordsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setKeywords(e.target.value);
  };

  const toggleTextBox = () => {
    setIsTextBoxVisible((prev) => !prev); // Toggle text box visibility
  };

  useEffect(() => {
    // Predefined keyword phrases
    const keywords = [
      "Solar", "Solar panel installation", "Best solar companies near me", "Solar energy cost savings",
      "Home solar financing options", "Solar tax credits 2025", "Residential solar systems",
      "Buy solar panels online", "Solar panel efficiency comparison", "Solar leasing vs buying",
      "Solar battery storage solutions", "How much do solar panels cost", "Off-grid solar systems",
      "Best solar panels for homes", "Solar installation incentives", "Solar power for home use",
      "Auto Warranty", "Best extended car warranty", "Car warranty companies near me",
      "Is an extended warranty worth it?", "Bumper-to-bumper warranty cost", "Cheap auto warranty plans",
      "Vehicle protection plans", "Used car extended warranty", "Compare car warranty providers",
      "Auto warranty scams to avoid", "What does an extended warranty cover?",
      "Best car warranty for older vehicles", "New car warranty options",
      "Car repair insurance vs extended warranty", "Auto service contracts explained",
      "Factory vs third-party warranties", "Mortgage", "Best mortgage rates today",
      "Mortgage refinance options", "First-time homebuyer loans", "FHA vs conventional mortgage",
      "Mortgage pre-approval process", "How much mortgage can I afford?",
      "Compare mortgage lenders", "30-year vs 15-year mortgage", "VA home loan benefits",
      "Home equity loan vs HELOC", "Best banks for mortgage loans",
      "Mortgage closing costs explained", "Adjustable-rate mortgage vs fixed",
      "Mortgage calculator with taxes and insurance", "How to get a low mortgage rate",
      "Windows", "Best window replacement companies", "Energy-efficient windows for homes",
      "Window installation cost", "Vinyl vs wood windows", "Double-pane vs triple-pane windows",
      "How much do new windows cost?", "Best brands for home windows", "Window financing options",
      "Cheap window replacements near me", "DIY window installation guide",
      "Sliding vs casement windows", "Hurricane-proof windows cost", "Window insulation for winter",
      "Custom windows for homes", "Best time to replace windows", "Roofing",
      "Best roofing contractors near me", "Roof replacement cost estimator", "Metal roof vs shingles",
      "Affordable roofing solutions", "Best roofing materials for hot climates",
      "How long does a new roof last?", "Roof financing options", "Flat roof vs pitched roof",
      "Emergency roof repair services", "DIY roof repair guide", "Best time of year to replace a roof",
      "Energy-efficient roofing options", "Roofing warranty comparison",
      "How to choose a roofing contractor", "Solar shingles vs solar panels",
      "Home Remodeling", "Best home remodeling companies", "Kitchen remodel cost estimator",
      "Bathroom renovation ideas", "Home renovation financing options", "Cheap home remodeling ideas",
      "DIY vs professional home remodeling", "Basement finishing cost",
      "Best flooring options for homes", "Interior home design trends", "Smart home upgrades 2025",
      "Open concept kitchen remodel", "Cost of adding a room to a house",
      "Home remodeling return on investment", "Whole-house renovation guide",
      "How to hire a home remodeling contractor"
    ];
  
    setAvailableKeywords(keywords);
  }, []);
  
  

  const handleDoubleClick = (keyword: any) => {
    // Handle double click (move keyword between available and selected lists)
    if (selectedKeywords.includes(keyword)) {
      setSelectedKeywords((prev) => prev.filter((item) => item !== keyword));
      setAvailableKeywords((prev) => [...prev, keyword]);
    } else {
      setSelectedKeywords((prev) => [...prev, keyword]);
      setAvailableKeywords((prev) => prev.filter((item) => item !== keyword));
    }
  };

  return (
    <div style={{ marginLeft: '30px' }}>
      <div style={{ marginTop: '20px' }}>
        <label>
          <input
            type="radio"
            name="enableDropdown"
            checked={isRadioChecked1}
            onChange={() => setIsRadioChecked1((prev) => !prev)}
          />
          Enable RON (Run Of Network) - No Targeting <br />
          <p className='targetingText'>
            Choose this option if you want your ad to show for every impression served. This option is useful for websites <br /> that need high traffic volume at a lower price and for non-targeted products such as general downloads, casinos, general affiliate offers etc.
          </p>
        </label>
        <div style={{ marginLeft: '30px' }}>
          <div style={{ marginTop: '20px' }}>
            <button
              style={{ backgroundColor: 'transparent', borderWidth: '0px' }}
              onClick={isRadioChecked1 ? toggleTextBox : undefined}  // Only enable the button if radio button is checked
            >
              {isTextBoxVisible1 ? 'Set Negative Keywords ▶' : 'Set Negative Keywords ▲'} {/* Button text changes */}
            </button>

            {isTextBoxVisible1 && (
              <div>
                <p className='targetingText'>
                  Choose this option if you want your ad to show for every impression served. This option is useful for websites <br /> that need high traffic volume at a lower price and for non-targeted products such as general downloads, casinos, general affiliate offers etc.
                </p>

                <textarea
                  id="keywordsSelectedRON_ID"
                  wrap="off"
                  className="bdv_000000_Text_11"
                  style={{ width: '300px', height: '150px' }}
                  placeholder={`KEYWORD1\nKEYWORD2\n...`}
                  value={keywords}
                  onChange={handleKeywordsChange}
                ></textarea>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <label>
          <input
            type="radio"
            name="enableDropdown"
            checked={isRadioChecked}
            onChange={() => setIsRadioChecked((prev) => !prev)}
          />
          Enable Contextual Targeting <br></br>
          <p className='targetingText'>
            Use this tool to target your ads by keywords and brands. If you have a niche product, choose keywords and brands that are related to your business.
          </p>
          <h1 className='Targetingheading' style={{ marginLeft: '10px' }}>Use broad phrases only, preferably 1 keyword per phrase and max of 2.</h1>

          <p style={{ marginLeft: '10px' }}>
            <b>Important:</b> Using brand names of leading companies that offer a similar product to yours can get you highly engaged visitors! For example, use the keyword "adidas" when running promotion for sports shoes (or even for a competing brand).
          </p>
        </label>
        <div style={{ marginLeft: '30px' , display: 'flex'}}>

          {/* Available Keywords */}
          <div style={{ width: '300px', fontSize: '12px' }}>
            <h3 className="Geoheading">Available Keywords</h3>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                border: "1px solid #ccc",
                height: "500px",
                overflowY: "scroll",
              }}
            >
              {availableKeywords.map((keyword, index) => (
                <li
                  key={index}
                  style={{
                    padding: "2px 5px",
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer", // Pointer cursor on hover
                  }}
                  onDoubleClick={() => handleDoubleClick(keyword)} // Add double-click handler
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{textTransform: "capitalize"}}>{keyword}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Buttons Container */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button

            style={{
              backgroundColor:'#1173b7',
              marginLeft:'5px',
              marginRight:'5px',
              padding:'5px',
              color:'white',
              border:'0px'
            }}
              onClick={() => {
                setSelectedKeywords((prev) => [...prev, ...availableKeywords]);
                setAvailableKeywords([]);
              }}
            >
              Add All &gt;&gt;
            </button>
            <button
             style={{
              backgroundColor:'#1173b7',
              marginLeft:'5px',
              marginRight:'5px',
              padding:'5px',
              color:'white',
              border:'0px'

            }}
              onClick={() => {
                setAvailableKeywords((prev) => [...prev, ...selectedKeywords]);
                setSelectedKeywords([]);
              }}
            >
              &lt;&lt; Remove All
            </button>
          </div>

          {/* Selected Keywords */}
          <div style={{ width: '300px', fontSize: '12px' }}>
            <h3 className="Geoheading">Selected Keywords</h3>
            <ul
              style={{
                listStyle: "none",
                padding: "2px 5px",
                border: "1px solid #ccc",
                height: "500px",
                overflowY: "scroll",
              }}
            >
              {selectedKeywords.map((keyword, index) => (
                <li
                  key={index}
                  style={{
                    padding: "0px",
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer", // Pointer cursor on hover
                  }}
                  onDoubleClick={() => handleDoubleClick(keyword)} // Add double-click handler
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{textTransform: "capitalize"}}>{keyword}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetingStep;
